import React, { lazy } from 'react';
import Suspense from '../layout/Suspense';

const LazyComponent = lazy(() => import('./Dashboard'));

export default () => {
  return <Suspense lazyComponent={<LazyComponent />} />;
};
